import config from '../../config/config';
export const getReCaptchaToken = async () => {
	try {
		const { grecaptcha } = window as any;
		await new Promise((res) => grecaptcha.ready(() => res(true)));

		const token = await new Promise((res) => {
			grecaptcha.execute(config.googleCaptchaClientKey, {action: 'submit'}).then(function(token: string) {
				res(token)
			});
		})

		return token;
	} catch (err) {
		console.error(err);
		return;
	}

}